import { bindStickyFiltersClick } from '../../Shared/js/utils/bindStickyFilters';

(function () {
    'use strict';

    function main() {
        var searchController = {
            init: function () {
                WhistleOut.getAds('Broadband');
                bindStickyFiltersClick(wo$('#sticky-filters'));
            }
        };
        searchController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
